import instaclustrComponent from "./Components";

export class Component extends instaclustrComponent {
    constructor(name, node) {
        super(name, node);
    }
    init() {
        console.log(this.name);

        // Get all counters on page
        const $counters = $('.component.component-counter-2024');

        // Counter animation function
        // Credit: https://codepen.io/chriscoyier/pen/xxVBqEg
        function animateValue(obj, start, end, duration) {
            let startTimestamp = null;
            const step = (timestamp) => {
                if (!startTimestamp) startTimestamp = timestamp;
                const progress = Math.min((timestamp - startTimestamp) / duration, 1);
                obj.innerHTML = Math.floor(progress * (end - start) + start);
                if (progress < 1) {
                    window.requestAnimationFrame(step);
                }
            };
            window.requestAnimationFrame(step);
        }

        // Create an observer to trigger the counter when it comes into view on the page
        const intersectionCallback = (entries) => {
            for (const entry of entries) { // Loop over all elements that either enter or exit the view.
                if (entry.isIntersecting) { // This is true when the element is in view
                    let target   = entry.target;
                    let end      = target.dataset.countEnd;
                    let duration = target.dataset.countDuration;
                    animateValue(entry.target, 0, end, duration);
                }
            }
        }
        const observer = new IntersectionObserver(intersectionCallback);
        for (const $counter of $counters) {
            observer.observe($counter);
        }

    }
}